// 短信报修记录

const requestSms = [
  {
    path: '/request-sms',
    name: 'requestSmsPage',
    meta: { tag: '短信报修' },
    component: () => import('@/pages/RequestSmsPage')
  }
]

export default requestSms
